var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashBoardIconInactive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 9.08123V17.7484C18.5 18.5768 17.8284 19.2484 17 19.2484H13.25C12.4216 19.2484 11.75 18.5768 11.75 17.7484V13.9984C11.75 13.5842 11.4142 13.2484 11 13.2484H8C7.58579 13.2484 7.25 13.5842 7.25 13.9984V17.7484C7.25 18.5768 6.57843 19.2484 5.75 19.2484H2C1.17157 19.2484 0.5 18.5768 0.5 17.7484V9.08123C0.499936 8.6615 0.67573 8.26095 0.984688 7.97685L8.48469 0.900601L8.495 0.890288C9.06719 0.369914 9.94124 0.369914 10.5134 0.890288C10.5166 0.893956 10.5201 0.897402 10.5238 0.900601L18.0238 7.97685C18.3296 8.26243 18.5022 8.66279 18.5 9.08123V9.08123Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashBoardIconInactive);
export default __webpack_public_path__ + "static/media/DashBoardIconInactive.9fb267aee3a9fc2cb66a0fbc29698bf6.svg";
export { ForwardRef as ReactComponent };